var render = function render(){var _vm=this,_c=_vm._self._c;return _c('empty-component',{attrs:{"text":"暂无预售订单信息"}})
}
var staticRenderFns = []

export { render, staticRenderFns }